module.exports = __webpack_public_path__ + "img/ContratoSVNacional1.980053ae.jpg";